var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app-store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.904,
    height: 19.904,
    viewBox: "0 0 19.904 19.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6910",
    "data-name": "Group 6910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11878",
    "data-name": "Path 11878",
    d: "M15.822,0H4.082A4.087,4.087,0,0,0,0,4.082v11.74A4.087,4.087,0,0,0,4.082,19.9h11.74A4.087,4.087,0,0,0,19.9,15.822V4.082A4.087,4.087,0,0,0,15.822,0Zm2.916,15.822a2.919,2.919,0,0,1-2.916,2.916H4.082a2.919,2.919,0,0,1-2.916-2.916V4.082A2.919,2.919,0,0,1,4.082,1.166h11.74a2.919,2.919,0,0,1,2.916,2.916Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6913",
    "data-name": "Group 6913",
    transform: "translate(3.324 4.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6912",
    "data-name": "Group 6912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11879",
    "data-name": "Path 11879",
    d: "M94.058,105.727a.972.972,0,0,0-1.78-.234l-.15.259-.15-.259a.973.973,0,0,0-1.328-.356h0a.973.973,0,0,0-.356,1.328l.711,1.231-2.622,4.542H86.472a.972.972,0,0,0,0,1.944h7.381l-1.122-1.944h-2.1l3.333-5.773A.965.965,0,0,0,94.058,105.727Z",
    transform: "translate(-85.5 -105.006)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6915",
    "data-name": "Group 6915",
    transform: "translate(10.401 7.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6914",
    "data-name": "Group 6914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11880",
    "data-name": "Path 11880",
    d: "M272.755,197.931h-1.912l-2.173-3.765-1.122,1.944,3.375,5.845a.966.966,0,0,0,.59.453.978.978,0,0,0,.253.034.973.973,0,0,0,.84-1.458l-.64-1.109h.79a.972.972,0,0,0,0-1.944Z",
    transform: "translate(-267.548 -194.166)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6917",
    "data-name": "Group 6917",
    transform: "translate(4.315 14.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6916",
    "data-name": "Group 6916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11881",
    "data-name": "Path 11881",
    d: "M111.324,361l-.191.331a.972.972,0,0,0,1.683.972l.752-1.3Z",
    transform: "translate(-111.003 -361)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e51fef499fc14fb51e0901cff7412323.svg";
export { ForwardRef as ReactComponent };